import React from "react"
import ReactDOM from "react-dom"
import MerchantCarousel from "./merchant-carousel"

export default class MerchantCarouselModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MerchantCarousel {...self.modelJson} />, self.elem)
  }
}
